import React from 'react';
import { HeaderFilterTable } from '@/components/common';
import { useFilters } from '@/hooks';
import { Options } from '@/components/ui/combobox';
interface RoleFilterProps {
	roleOptions: Options[];
}

export const RoleFilter: React.FC<RoleFilterProps> = ({ roleOptions }) => {
	const filterKey = 'role';
	const { setParamFilter, hasFilter, query } = useFilters();
	const [selected, setSelected] = React.useState<string[]>([]);

	const handleSelectFilters = (value?: string): void => {
		if (value) {
			const newSelected = selected.includes(value)
				? selected.filter((s) => s !== value)
				: [...selected, value];
			setParamFilter(filterKey, newSelected.join(','));
		}
	};

	const handleClearAll = (): void => {
		setParamFilter(filterKey, '');
		setSelected([]);
	};

	React.useEffect(() => {
		const queryParam = query[filterKey] as string;
		if (queryParam) {
			const value = queryParam.split(',');
			setSelected(value);
		} else {
			setSelected([]);
		}
	}, [query]);

	return (
		<HeaderFilterTable
			title="Role"
			searchTitle="Filter by"
			values={selected}
			type="multiple"
			filterOptions={roleOptions}
			handleClearAll={handleClearAll}
			handleSelectFilters={handleSelectFilters}
			hasFilter={hasFilter(filterKey)}
			classNamePopoverContent="lg:w-[185px]"
		/>
	);
};
